type NativePlatform = "android" | "ios";

type NativeVersionEnv = Partial<{
  VITE_MIN_SUPPORTED_NATIVE_BUILD_ANDROID: number | string;
  VITE_MIN_SUPPORTED_NATIVE_BUILD_IOS: number | string;
  VITE_MIN_SUPPORTED_NATIVE_VERSION_ANDROID: string;
  VITE_MIN_SUPPORTED_NATIVE_VERSION_IOS: string;
}>;

const DEFAULT_MIN_SUPPORTED_NATIVE_VERSION_ANDROID = "1.1.9";
const DEFAULT_MIN_SUPPORTED_NATIVE_VERSION_IOS = "1.1.9";
const DEFAULT_MIN_SUPPORTED_NATIVE_BUILD_ANDROID = 16;
const DEFAULT_MIN_SUPPORTED_NATIVE_BUILD_IOS = 1;

function parseBuildNumber(
  value: number | string | undefined,
  fallback: number
) {
  const parsed =
    typeof value === "number"
      ? value
      : typeof value === "string"
      ? Number(value)
      : NaN;
  return Number.isFinite(parsed) ? parsed : fallback;
}

function getMinSupportedNativePolicy(
  platform: NativePlatform,
  env: NativeVersionEnv
) {
  if (platform === "ios") {
    return {
      minBuild: parseBuildNumber(
        env.VITE_MIN_SUPPORTED_NATIVE_BUILD_IOS,
        DEFAULT_MIN_SUPPORTED_NATIVE_BUILD_IOS
      ),
      minVersion:
        env.VITE_MIN_SUPPORTED_NATIVE_VERSION_IOS ??
        DEFAULT_MIN_SUPPORTED_NATIVE_VERSION_IOS,
    };
  }

  return {
    minBuild: parseBuildNumber(
      env.VITE_MIN_SUPPORTED_NATIVE_BUILD_ANDROID,
      DEFAULT_MIN_SUPPORTED_NATIVE_BUILD_ANDROID
    ),
    minVersion:
      env.VITE_MIN_SUPPORTED_NATIVE_VERSION_ANDROID ??
      DEFAULT_MIN_SUPPORTED_NATIVE_VERSION_ANDROID,
  };
}

export { getMinSupportedNativePolicy };
export type { NativePlatform, NativeVersionEnv };
